// These interface labels are bundled with the app, independently of the CMS.
export const selectionTranslations = {
    en: {
        'loading': 'Loading…',
        'back-to-homepage': 'Back to homepage',
        'premium-quiz-area': 'Premium quiz area',
        'buy-access': 'Buy access',
        'free-quiz-area': 'FREE',
    },
    es: {
        'loading': 'Cargando…',
        'back-to-homepage': 'Volver al inicio',
        'premium-quiz-area': 'Área de quiz prémium',
        'buy-access': 'Comprar acceso',
        'free-quiz-area': 'GRATIS',
    },
    fr: {
        'loading': 'Chargement…',
        'back-to-homepage': 'Retour à l’accueil',
        'premium-quiz-area': 'Espace quiz premium',
        'buy-access': 'Acheter l’accès',
        'free-quiz-area': 'GRATUIT',
    },
};
